import React, { useEffect, useState } from "react"
import { Box, Grid, Typography } from "@mui/material"
import RecipeCard from "./recipeCard"

const NewestRecipes = () => {
  const [newestRecipes, setNewestRecipes] = useState([])

  useEffect(() => {
    const fetchNewestRecipes = async () => {
      try {
        const response = await fetch("/api/recipes/recent")
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        const recipes = await response.json()
        setNewestRecipes(recipes)
      } catch (error) {
        console.error("Error fetching newest recipes:", error)
      }
    }

    fetchNewestRecipes()
  }, [])

  return (
    <Box mt={4}>
      <Typography variant="h4" component="div" mb={2}>
        Our Newest Recipes
      </Typography>
      <Grid container spacing={4}>
        {newestRecipes.map((recipe) => (
          <Grid item xs={12} md={3} key={recipe._id}>
            <RecipeCard recipe={recipe} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default NewestRecipes
